export { default } from "./MHALocationSearch.gql";
